import { render } from "./DashboardElement.vue?vue&type=template&id=0f237726&scoped=true"
import script from "./DashboardElement.vue?vue&type=script&lang=js"
export * from "./DashboardElement.vue?vue&type=script&lang=js"

import "./DashboardElement.vue?vue&type=style&index=0&id=0f237726&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f237726"]])

export default __exports__